import { DataLoader } from 'DataLoader';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MatrixProvider } from 'matrix/MatrixProvider';
import React, { useEffect } from 'react';
import { Provider } from 'urql';
import { BpAuthProvider } from './BpAuthProvider';
import { AppLayoutContextProvider } from './context/AppLayoutContext';
import { ErrorBoundary } from './ErrorBoundary';
import { RequireAuth } from './RequireAuth';
import { RequireBackend } from './RequireBackend';
import { RequireMatrix } from './RequireMatrix';
import { urqlClient } from './utils/urqlClient';

export function App() {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const _mtm = (window._mtm = window._mtm || []);
    _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
    (() => {
      const d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = 'https://matomo.tks.eu/js/container_fiWk8aXC_dev_0adbd5f799f9ebfc57fb7395.js';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      s.parentNode.insertBefore(g, s);
    })();
  }, []);

  return (
    <ErrorBoundary>
      <BpAuthProvider>
        <RequireAuth>
          <RequireMatrix>
            <RequireBackend>
              <Provider value={urqlClient}>
                <QueryClientProvider client={new QueryClient()}>
                  <MatrixProvider>
                    <AppLayoutContextProvider>
                      <DataLoader />
                    </AppLayoutContextProvider>
                  </MatrixProvider>
                </QueryClientProvider>
              </Provider>
            </RequireBackend>
          </RequireMatrix>
        </RequireAuth>
      </BpAuthProvider>
    </ErrorBoundary>
  );
}
